import { CheckboxField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { changeWithPhoto } from '../../../state/with_photo';
import { InlineParam, Row } from '../markup';

export interface IPhotoProps {
  withPhoto: boolean | undefined;
  onWithPhotoChanged(value: boolean | undefined): void;
}

export const photo: React.StatelessComponent<IPhotoProps> = ({ withPhoto, onWithPhotoChanged }) => {
  return (
    <Row title="Наличие фото">
      <InlineParam>
        <CheckboxField onValueChange={onWithPhotoChanged} value={withPhoto || false} label="Только с фото" />
      </InlineParam>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect<
  {
    withPhoto: boolean | undefined;
  },
  {
    onWithPhotoChanged(value: boolean | undefined): void;
  },
  {}
>(
  (state: IAppState) => ({
    withPhoto: state.filters.jsonQuery.wp && state.filters.jsonQuery.wp.value,
  }),
  (dispatch: Dispatch) => ({
    onWithPhotoChanged: (value: boolean | undefined) => {
      dispatch(changeWithPhoto(value));
    },
  }),
)(photo);
